import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    IconButton,
    Typography
} from '@mui/material';
import { FC, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { PDFIcon } from '../../../vectors/index';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { darkBlue } from '@styles/colors';
type DownloadFormModalProps = {
    handleClose: () => void;
    item: any;
};

const DownloadFormModal: FC<DownloadFormModalProps> = ({
    handleClose,
    item,
}) => {

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <PDFIcon />
                <br />
                <Typography variant="h4" sx={{ p: 3 }}>
                    Download Forms
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} >
                    <Button variant="text"
                        size="small"
                        component='a'
                        href={`https://app.staffedup.com/rockerbox/applicants/8850/?application_id=${item.id}`}
                        target="_blank"
                        startIcon={<PictureAsPdfIcon />}
                        sx={{ textDecoration: "underline", color: darkBlue }}
                    >
                        Form 8850
                    </Button>
                    <Button variant="text"
                        size="small"
                        component='a'
                        href={`https://api2.staffedup.com/rockerbox/applicants/9175/?application_id=${item.id}`}
                        target="_blank"
                        startIcon={<PictureAsPdfIcon />}
                        sx={{ textDecoration: "underline", color: darkBlue }}
                    >
                        Form 9175
                    </Button>
                    <Button variant="text"
                        size="small"
                        component='a'
                        href={`https://api2.staffedup.com/rockerbox/applicants/9061/?application_id=${item.id}`}
                        target="_blank"
                        startIcon={<PictureAsPdfIcon />}
                        sx={{ textDecoration: "underline", color: darkBlue }}
                    >
                        Form 9061
                    </Button>
                </Stack>

            </DialogContent>
        </Dialog>
    );
};

export default DownloadFormModal;
